import { z } from "zod";

/**
 * `progress` domain DTOs (Master Spec §33/§39, Phase 10). Progress rows
 * are read-only from the client's perspective — there is deliberately no
 * `UpdateProgressRequestSchema` anywhere in this codebase. Per §19,
 * `level_progress` is only ever written server-side by
 * `progress.service.ts`'s `recordAttemptOutcome`, driven by an already-
 * persisted, already-idempotent `game_attempts` row — never trusted as a
 * client-sent aggregate.
 */
export const LevelProgressDTOSchema = z.object({
  levelId: z.string().uuid(),
  globalLevelNumber: z.number().int().min(1).max(100),
  completed: z.boolean(),
  mastered: z.boolean(),
  bestStars: z.number().int().min(0).max(3).default(0),
  bestDurationMs: z.number().int().nonnegative().nullable(),
  attemptsCount: z.number().int().nonnegative(),
});
export type LevelProgressDTO = z.infer<typeof LevelProgressDTOSchema>;

export const ListProgressResponseSchema = z.object({
  progress: z.array(LevelProgressDTOSchema),
});
export type ListProgressResponse = z.infer<typeof ListProgressResponseSchema>;
